import AlertIncidentSvc from '@/services/AlertIncidentSvc';
import getScopedAssets from '@/util/scopedAssets';

const MAX_TOTAL = 100;
const RECENT_WINDOW_MS = 24 * 60 * 60 * 1000;

function severityOf(incident) {
  return incident?.alinAlru?.alruSeverity === 'CRITICAL' ? 'danger' : 'warning';
}

function buildAlertNotifs(incidents, massIds) {
  const cutoff = Date.now() - RECENT_WINDOW_MS;
  const allowed = new Set(massIds);
  return incidents
    .filter((i) => allowed.has(i.alinMassId))
    .map((i) => ({
      id: `alert-${i.alinId}`,
      severity: severityOf(i),
      title: i.alinAlru?.alruName || 'Alert',
      status: i.alinStatus === 'ACTIVE' ? 'Active' : 'Resolved',
      shipName: i.alinMass?.massName || '',
      massId: i.alinMassId,
      time: i.alinStartedAt,
      raw: i,
    }))
    .filter((n) => new Date(n.time).getTime() >= cutoff)
    .sort((a, b) => new Date(b.time) - new Date(a.time))
    .slice(0, MAX_TOTAL);
}

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
  },
  getters: {
    notifications: (state) => state.items,
    unreadCount: (state) => state.items.length,
    loading: (state) => state.loading,
  },
  mutations: {
    SET_ITEMS(state, items) { state.items = items; },
    SET_LOADING(state, v) { state.loading = v; },
  },
  actions: {
    async fetch({ commit }) {
      commit('SET_LOADING', true);
      try {
        let massIds = [];
        try {
          const assets = await getScopedAssets();
          massIds = assets.map((a) => a.massId).filter(Boolean);
        } catch (e) {
          console.error('alert incident asset scope fetch failed:', e);
          return;
        }

        if (!massIds.length) {
          commit('SET_ITEMS', []);
          return;
        }

        const res = await AlertIncidentSvc.getIncidents({
          finds: { alinMassId: massIds },
          orders: { alinStartedAt: 'desc' },
          params: { max: MAX_TOTAL },
        });

        commit('SET_ITEMS', buildAlertNotifs(res?.data || [], massIds));
      } catch (e) {
        console.error('alert incident fetch failed:', e);
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
